import { useState } from "react";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { Button, Layout, Menu, theme } from "antd";
import { DASHBOARD } from "../constants/AppConstants";
import { callLogout } from "../services/authService";
import PayMethodsList from "../components/Dashboard/Payment/PayMethods/PayMethodList/PayMethodList";
import LottoList from "../components/Dashboard/Lotto/LottoList/LottoList";
import WinnersList from "../components/Dashboard/Winners/WinnersList/WinnersList";
import Movements from "../components/Dashboard/Movements/Movements";
import Statistics from "../components/Dashboard/Statistics/Statistics";
import PhonesList from "../components/Dashboard/Phones/PhonesList/PhonesList";
import MetaTemplateList from "../components/Dashboard/MetaTemplate/MetaTemplateList/MetaTemplateList";

import logo from "../assets/images/Logo-Rifas-Gran-Familia.png";
import TicketMovements from "../components/Dashboard/Reports/TicketMovements/TicketMovements";


const { Header, Sider, Content, Footer } = Layout;

export default function Dashboard() {
  const [selectedKey, setSelectedKey] = useState("lottos");
  const [collapsed, setCollapsed] = useState(false);
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();


  const renderContent = () => {
    switch (selectedKey) {
      case "lottos":
        return <LottoList />;
      case "winners":
        return <WinnersList />;
      case "participants":
        return <>Participantes</>;
      case "pay_methods":
        return <PayMethodsList />;
      case "phones":
        return <PhonesList />;
      case "movements":
        return <Movements />;
      case "statistics":
        return <Statistics />;
      case "meta_template":
        return <MetaTemplateList />;
      case "report_ticket_movements":
        return <TicketMovements />;
      case "logout":
        callLogout();
        window.location.reload();
        return null;
      default:
        return <div>Selecciona una opción del menú</div>;
    }
  };


  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        style={{
          backgroundColor: "white",
          borderInlineEnd: "1px solid rgba(5,5,5,0.06)",
        }}
      >
        <div className="demo-logo-vertical" />
        <img
          src={logo}
          alt="Rifas Gran Familia GDL"
          style={
            collapsed
              ? { maxHeight: "60px", objectFit: "contain", width: "100%" }
              : { maxHeight: "90px", objectFit: "contain", width: "100%" }
          }
        />
        <Menu
          mode="inline"
          defaultSelectedKeys={[selectedKey]}
          items={DASHBOARD.ITEMS}
          onClick={({ key }) => setSelectedKey(key)}
          style={{ borderInlineEnd: "none" }}
        />
      </Sider>
      <Layout>
        <Header style={{ padding: 0, background: colorBgContainer }}>
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{
              fontSize: "16px",
              width: 64,
              height: 64,
            }}
          />
        </Header>
        <Content
          style={{
            margin: "24px 16px",
            padding: 24,
            minHeight: 280,
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
            overflowX: "auto",
          }}
        >
          {renderContent()}
        </Content>
        <Footer style={{ textAlign: "center" }}>
          Rifas Gran Familia GDL ©{new Date().getFullYear()}
        </Footer>
      </Layout>
    </Layout>
  );
}
